<app-header></app-header>

<div class="page-content">
  <h1 class="webapp-title">Preguntas frecuentes</h1>
  <div class="services-accordion">
      <mat-accordion>
          <mat-expansion-panel *ngFor="let faq of faqs;let i = index;" class="serviceItem" (opened)="faq.panelOpenState = true" (closed)="faq.panelOpenState = false" hideToggle>
          <mat-expansion-panel-header>
              <mat-panel-title class="faq-row">
                  <img *ngIf="faq.image" class="service-avatar-img" src="{{faq.image}}">
                  
                  {{faq.question}}
                  <span *ngIf="faq.panelOpenState === false"><i class="fa fa-plus-circle service-icon"></i></span>
                  <span *ngIf="faq.panelOpenState === true"><i class="fa fa-minus-circle service-icon"></i></span>
              </mat-panel-title>
              <!-- <mat-panel-description>-</mat-panel-description> -->
          </mat-expansion-panel-header>
              <span class="answer">{{faq.answer}}</span>
              
          </mat-expansion-panel>
      </mat-accordion>
  </div>


  <app-faq-list></app-faq-list>

  <div>
      <img src="img/illustrations/support.jpg" alt="" class="help-center-banner">
      <h1 class="webapp-title">Contacta ahora</h1>
      <p>Estamos disponibles de Lunes a Viernes de 8am a 6pm.</p>
      <div class="help-center-links">
        <span class="link link-banner simple-link-banner link-chevron">
          <mat-icon class="icon margin-sides-1rem">phone</mat-icon>
          <div class="link-banner-text">
            <div class="link-banner-title">Contacta vía whatsapp</div>
          </div>
        </span>
        <span href="#" class="link link-banner simple-link-banner link-chevron">
        <mat-icon class="icon margin-sides-1rem">video_call</mat-icon>
          <div class="link-banner-text">
            <div class="link-banner-title">Reservar una videollamada</div>
          </div>
        </span>
      </div>

  </div>
  
</div>

<app-footer></app-footer>
